import { useEffect, useState } from 'react'
import { useAppSelector } from '../redux/hooks'
import { makeSelectFavoris } from '../redux/features/favoris/selectors'
import BienAVendreFilters from '../enums/BienAVendreFilters'
import { checkParcelleVue } from '../utils/parcellesVues'
import selectBienAVendreResultFilter from '../redux/features/filterResult/selectors'

interface ReturnProps {
  estRetireParLeFiltrage: (parcelleUuid: string) => boolean
}

const useFiltreBienAVendre = (): ReturnProps => {
  const favoris = useAppSelector(makeSelectFavoris)
  const [favorisArray, setFavorisArray] = useState<string[]>([])
  const bienAVendreResultFilter = useAppSelector(selectBienAVendreResultFilter)

  useEffect(() => {
    const result: string[] = []
    Object.keys(favoris).forEach((key) => {
      if (favoris[key].isActive) {
        result.push(key)
      }
    })
    setFavorisArray(result)
  }, [favoris])

  const checkIsFavoriInResult = (parcelleUuid: string): boolean =>
    favorisArray.includes(parcelleUuid)

  const estRetireParLeFiltrage = (parcelleUuid: string): boolean =>
    (bienAVendreResultFilter.filter === BienAVendreFilters.Favoris &&
      !checkIsFavoriInResult(parcelleUuid)) ||
    (bienAVendreResultFilter.filter === BienAVendreFilters.DejaVus &&
      checkParcelleVue(parcelleUuid))

  return {
    estRetireParLeFiltrage,
  }
}

export default useFiltreBienAVendre
